import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { faqs } from "@/data/content";

export default function FaqSection() {
  return (
    <section className="bg-white py-24 lg:py-32" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="FAQ"
          title="Questions, Answered"
          subtitle="Everything you need to know about working with HM Services."
        />
        <Reveal className="mt-14">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="overflow-hidden rounded-2xl border border-line bg-white px-6 shadow-sm data-[state=open]:shadow-float"
              >
                <AccordionTrigger className="py-5 text-left font-serif text-lg font-medium text-navy hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-600">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
